import { SQUAD_VEHICLES } from '../pages/Squad/Create/constants';
const DisplaySquadVehicle = (vehicleValue: any) => {
  const vehicle = SQUAD_VEHICLES.find(v => v.value === vehicleValue);
  return vehicle ? vehicle.display : '-';
};

export default DisplaySquadVehicle;
